import { ProjectHelper } from 'src/app/core';

import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'filterSystemLevelElements',
    standalone: false
})
export class FilterSystemLevelElements implements PipeTransform {
  constructor(private projectHelper: ProjectHelper) {}

  transform(array: any[]): any[] {
    try {
      const elements = this.projectHelper.filterOutSystemAccessLevelElements(array);
      return elements;
    } catch (error) {
      console.log('error', error);
      throw 'Cannot Filter System Level Elements in the tree';
    }
  }
}
